import { aesEncrypt } from "./key";
export const formatPassword: (password: string) => string = (password: string) => {
  return aesEncrypt(password);
}